export class DateRangeFromTo {
    public fromDate: Date = new Date;
    public toDate: Date = new Date;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/dateRangeFromTo.viewModel.ts